import { useQuery } from "@tanstack/react-query";
import { AIConfiguredModelProviders } from "@graylog/enterprise-api";
import { defaultOnError } from "util/conditional/onError";
import { MODEL_PROVIDERS_QUERY_KEY, toConfiguredModelProvider } from "./fetchModelProviders";
const useConfiguredModelProviders = ({ enabled = true } = {}) => {
  const { data, isLoading } = useQuery({
    queryKey: [...MODEL_PROVIDERS_QUERY_KEY, "all"],
    queryFn: () => defaultOnError(
      AIConfiguredModelProviders.listConfiguredProviders().then(
        ({ elements }) => elements.map(toConfiguredModelProvider)
      ),
      "Loading model providers failed",
      "Could not load model providers"
    ),
    enabled
  });
  return { data: data != null ? data : [], isLoading };
};
export default useConfiguredModelProviders;
